import { render, staticRenderFns } from "./AccountStatementView.vue?vue&type=template&id=bef8f0dc&scoped=true"
import script from "./AccountStatementView.vue?vue&type=script&lang=js"
export * from "./AccountStatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef8f0dc",
  null
  
)

export default component.exports